var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not_data_box"},[(!_vm.$slots.img)?_c('img',{staticClass:"not_data_img",attrs:{"src":require("./notDataImg.png"),"alt":""}}):_vm._e(),_vm._t("img"),(!_vm.$slots.msg)?_c('div',{staticClass:"not_msg"},[_vm._v("暂无数据")]):_vm._e(),_vm._t("msg"),_vm._t("btns"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }